import type {
  Configuration,
  PopupRequest,
  RedirectRequest,
} from "@azure/msal-browser";
import { config } from "../application/common/static-config";

const authScopes = config.AUTH_SCOPE.split(/[,\s]+/).filter(Boolean);

// Helper function to detect mobile devices
const isMobile = (): boolean => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) || window.innerWidth <= 768
  );
};

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: config.AZURE_CLIENT_ID,
    authority: config.AUTHORITY,
    redirectUri: config.AUTH_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: false, // Important: Prevents navigation to request URL after login
    postLogoutRedirectUri:
      config.AUTH_LOGOUT_REDIRECT_URI || window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Enable cookie storage to handle redirect flow better on mobile
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.log(`MSAL [${level}]: ${message}`);
      },
      piiLoggingEnabled: false,
      logLevel: process.env.NODE_ENV === "development" ? 3 : 1, // Verbose in dev, Error in prod
    },
  },
};

// Add here scopes for id token to be used at MS Graph API endpoints.
export const loginRequest: PopupRequest = {
  scopes: authScopes,
};

// Redirect request configuration for mobile devices
export const redirectRequest: RedirectRequest = {
  scopes: authScopes,
  redirectUri: config.AUTH_REDIRECT_URI || window.location.origin,
};

// Export mobile detection function
export { isMobile };

// Add here the endpoints for MS Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
